import { useUserStore } from '@/store/UserStore'
import { useThemeStore } from '@/store/ThemeStore'

export default {
  data() {
    return {
      fetchingKpis: false,
    }
  },
  methods: {
    fetchKpis() {
      const ThemeStore = useThemeStore()
      const client = ThemeStore.client
      const url = process.env.VUE_APP_BASE_URL + '/data/Scorm/Kpis?client=' + client
      const accessToken = this.$cookies.get('access_token')

      if (!accessToken) return

      this.fetchingKpis = true

      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: 'Bearer ' + accessToken
      }

      this.$http.get(url, { headers: headers }).then(
        res => {
          const UserStore = useUserStore()

          if (res.data) {
            UserStore.setKpis(res.data)
          }

          this.fetchingKpis = false
        },
        error => {
          this.fetchingKpis = false

          if (error.response && error.response.status === 401) {
            this.refreshToken(() => {
              this.fetchKpis()
            })
          }
        }
      )
    }
  }
}